import type { IconSvgObject } from './types';

const InsertColumnRightIcon: IconSvgObject = [
  ["path", { d: "M18.5 9.00098L21.5 12.001L18.5 15.001M20.5 12.001L13.5 12.001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 2.49902V21.499", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 8.49902H9M2.5 15.499H9", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21.5 7.00098V5.50098C21.5 3.84412 20.1569 2.50098 18.5 2.50098H5.5C3.84315 2.50098 2.5 3.84412 2.5 5.50098V18.501C2.5 20.1578 3.84315 21.501 5.5 21.501H18.5C20.1569 21.501 21.5 20.1578 21.5 18.501V17.001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default InsertColumnRightIcon;
